import { render, staticRenderFns } from "./CredentialsExpiredForm.vue?vue&type=template&id=c6978292"
import script from "./CredentialsExpiredForm.vue?vue&type=script&lang=js"
export * from "./CredentialsExpiredForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports